import { createFileRoute } from '@tanstack/react-router'
import MainPageTemplate from '@/components/layout/page-templates/main/MainPageTemplate'

export const Route = createFileRoute('/_main')({
  component: MainPageTemplate,
})
